import { I18n } from '@calendly/i18n'
import { Loader } from '@calendly/ui/components/loader'
import { useEffect, useRef, useState } from 'react'
import { Redirect, useLocation, useParams } from 'react-router-dom'

import { useGetUserQuery } from 'common'

import { useGetAvailabilitySchedulesQuery } from '../api'
import { Header } from './header'
import { Schedules } from './schedules'
import { useSchedulesRoutes } from './schedules_routes_context'
import { TabPage } from '../components/tab_page'

export const SchedulesTab = ({
  currentScheduleId,
  currentEventType,
  trackLocation,
  onClose,
  withinModal: withinModalProp,
  omitOuterBorder,
}) => {
  const layoutWithinModal = withinModalProp ?? Boolean(onClose)
  const formInnerRef = useRef(null)
  const formContentRef = useRef(null)
  const [isFormDirty, setIsFormDirty] = useState(false)
  const { data: { primary_availability_rule_id: defaultScheduleId } } = useGetUserQuery()
  const { data, isLoading, isFetching, isError, refetch } = useGetAvailabilitySchedulesQuery()
  const params = useParams()
  const { search } = useLocation()
  const schedulesRoutes = useSchedulesRoutes()
  const routeScheduleId = schedulesRoutes.parseRouteScheduleId(params, search)

  useEffect(() => {
    refetch()
  }, [refetch])

  if (isError || !data) return null
  if (isLoading) return <Loader />

  const rawScheduleToken = currentScheduleId != null && currentScheduleId !== ''
    ? currentScheduleId
    : routeScheduleId
  const selectedScheduleId = rawScheduleToken === undefined
    ? Number(defaultScheduleId)
    : Number(rawScheduleToken)
  const allSchedules = data || []
  const selectedSchedule = allSchedules.find(({ id: scheduleId }) => scheduleId === selectedScheduleId)

  if (!selectedSchedule) {
    return isFetching
      ? <Loader />
      : <Redirect to={schedulesRoutes.invalidRedirectHref()} />
  }

  return (
    <TabPage
      ref={formContentRef}
      pageTitle={I18n.t('publisher.event_type_editor.sections.available_hours.schedules_label')}
      header={(
        <Header
          isFormDirty={isFormDirty}
          selectedScheduleId={selectedScheduleId}
          currentEventType={currentEventType}
          trackLocation={trackLocation}
          onClose={onClose}
        />
      )}
      withinModal={layoutWithinModal}
      omitOuterBorder={omitOuterBorder}
    >
      <Schedules
        formInnerRef={formInnerRef}
        formContentRef={formContentRef}
        setIsFormDirty={setIsFormDirty}
        selectedScheduleId={selectedScheduleId}
        currentEventType={currentEventType}
        trackLocation={trackLocation}
        onClose={onClose}
        withinModal={layoutWithinModal}
      />
    </TabPage>
  )
}
